import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__tensor_image_mask_boolean } from '../../_tensor/FIELD__tensor_image_mask_boolean';
import { FIELD__list_base_generic } from './FIELD__list_base_generic';

export class FIELD__list_tensor_image_mask_boolean extends FIELD__list_base_generic<FIELD__tensor_image_mask_boolean> {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_LIST__TENSOR_IMAGE_MASK_BOOLEAN;

  /*
   * STATIC METHODS
   */

  constructor() {
    super();

    this.item_connectable_type = ENUM__field_connectable_type.TENSOR_IMAGE_MASK_BOOLEAN;
  }

  protected override _create_item_internal__default() {
    return new FIELD__tensor_image_mask_boolean();
  }
}
